import { useEffect, useMemo, useState } from 'react';
import { MAutoComplete, MButton, MInput } from '@Components/Base';
import { Divider, Flex, Modal, Row, Col, Typography } from 'antd';

import { parseDateTime } from '@Utils/transformDateTime';
import { User } from '@Types/index';
import { transformUserOptions } from '@Utils/transformUserOptions';
import { DefaultOptionType } from 'antd/es/select';

interface SelectModalEmployeeProps {
  openSelectEmployeeModal: boolean;
  optionUsers: User[];
  currentUser: User | undefined;
  isMyselfUser: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  handleEmployeeTabClick: () => void;
  handleMySelfTabClick: () => void;
  handleSearchEmpByNumber: (empNumber: string) => void;
}

const SelectModalEmployee: React.FC<SelectModalEmployeeProps> = ({
  openSelectEmployeeModal,
  optionUsers,
  currentUser,
  isMyselfUser,
  handleSearchEmpByNumber,
  handleOk,
  handleCancel,
  handleEmployeeTabClick,
  handleMySelfTabClick,
}) => {
  const searchOptions = useMemo(
    () => transformUserOptions(optionUsers),
    [optionUsers]
  );
  const [searchValue, setSearchValue] = useState('');
  const [replacementOptions, setReplacementOptions] = useState(searchOptions);

  const onSelect = (data: string, option: DefaultOptionType): void => {
    handleSearchEmpByNumber(String(option.value));
  };

  useEffect(() => {
    setReplacementOptions(
      searchOptions.filter((option) =>
        option.label.toLowerCase().includes(searchValue.toLowerCase())
      )
    );
  }, [searchValue]);

  return (
    <Modal
      title="Select Employee"
      open={openSelectEmployeeModal}
      onOk={handleOk}
      okText="Apply"
      onCancel={handleCancel}
    >
      <Divider />
      <Row style={{ width: '100%', margin: '20px 0px' }}>
        <Col span={12}>
          <MButton style={{ width: '100%' }} onClick={handleEmployeeTabClick}>
            Employee
          </MButton>
        </Col>
        <Col span={11} push={1}>
          <MButton style={{ width: '100%' }} onClick={handleMySelfTabClick}>
            Myself
          </MButton>
        </Col>
      </Row>
      <Flex vertical gap={16}>
        {!isMyselfUser && (
          <MAutoComplete
            options={replacementOptions}
            onSelect={onSelect}
            onSearch={(searchString) => {
              setSearchValue(searchString);
            }}
          >
            <MInput
              searchInput
              placeholder="Search by employee ID or employee name..."
            />
          </MAutoComplete>
        )}

        <div>
          <Typography.Text strong>Employee ID</Typography.Text>
          <MInput
            name="empId"
            placeholder="Insert ID"
            value={currentUser?.empNumber}
          />
        </div>
        <div>
          <Typography.Text strong>Employee Name</Typography.Text>
          <MInput
            name="empNam"
            placeholder="Insert Employee Name"
            value={currentUser?.empName}
          />
        </div>
        <div>
          <Typography.Text strong>Date of Joining</Typography.Text>
          <MInput
            name="dateOfJoining"
            placeholder="DD.MM.YYYY"
            value={parseDateTime(currentUser?.startDate)}
          />
        </div>
        <div>
          <Typography.Text strong>Company</Typography.Text>
          <MInput
            name="company"
            placeholder="Insert Company"
            value={currentUser?.company}
          />
        </div>
        <div>
          <Typography.Text strong>Occupation</Typography.Text>
          <MInput
            name="occupation"
            placeholder="Insert Occupation"
            value={currentUser?.occupation}
          />
        </div>
        <div>
          <Typography.Text strong>Location</Typography.Text>
          <MInput
            name="location"
            placeholder="Insert Location"
            value={currentUser?.currentLocation}
          />
        </div>
      </Flex>
    </Modal>
  );
};
export default SelectModalEmployee;
